import { render, staticRenderFns } from "./page-dynamic-row-editor.vue?vue&type=template&id=06253c98&scoped=true&"
import script from "../../../js/views/dynamic-row-editor/page-dynamic-row-editor.js?vue&type=script&lang=js&"
export * from "../../../js/views/dynamic-row-editor/page-dynamic-row-editor.js?vue&type=script&lang=js&"
import style0 from "./page-dynamic-row-editor.vue?vue&type=style&index=0&id=06253c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06253c98",
  null
  
)

export default component.exports